export default __webpack_public_path__ + "static/media/mc-3-rMIN.64a06fa7.avif";